import { API } from 'aws-amplify';
import { API_NAME, getConfig, validateResponse, handleError } from './apiUtils';

/**
 *
 * @param {String} market Two character country code of the market/region
 * @param {String} category Business line or category of business
 * @param {String} brand Name of brand for which NBA Program is defined
 * @returns NBA Program Object if already created for the given market-category-brand combination.
 */
export async function getNbaProgram(market) {
    const path = `/v1/nbaadmin/${market}/nba-program`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        // .then(console.log(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

/**
 *
 * @param {String} market Two character country code of the market/region
 * @param {String} category Business line or category of business
 * @param {String} brand Name of brand for which NBA Program is defined
 * @param {Object} body Request body {"status": "DRAFT"} for a new program}
 * @returns NBA Program Object with the newly created Program details
 */
export async function createNbaProgram(market, body) {
    const path = `/v1/nbaadmin/${market}/nba-country`;
    return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

/**
 *
 * @param {String} market Two character country code of the market/region
 * @param {String} category Business line or category of business
 * @param {String} brand Name of brand for which NBA Program is defined
 * @param {Object} body Request body {"status": "PUBLISHED"} for a existing program}
 * @returns
 */

export async function updateNbaProgram(market, programId, body) {
    const path = `/v1/nbaadmin/${market}}/nba-program/${programId}`;
    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
